$(() => {
    $('.addAddress').click(() => {
        let newAddress = $('.for-cloning')
            .clone(true)
            .removeClass('for-cloning')
            .insertBefore($('.address-wrap.for-cloning'))
    })

    $('.removeAddress').click(() => {
        $(this)
            .parent('.address-wrap:not(.for-cloning)')
            .remove()
    })
})
